module.exports = __webpack_public_path__ + "static/media/pro_create.5be611c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/pro_create.svg
// module id = 478
// module chunks = 0